import { axiosInstance, ENDPOINT } from 'common/constants';
import { handleResponse } from 'common/helpers';

export const assetChartsComparisonRequest = params => dispatch =>
  handleResponse(axiosInstance.post(ENDPOINT.ASSET_CHARTS_COMPARISON, params));

export const assetChartComparisonPollOnce = taskId => dispatch =>
  handleResponse(
    axiosInstance.get(ENDPOINT.ASSET_CHARTS_COMPARISON_RESULTS(taskId))
  );
